import axios from 'axios'
import { getDefaultConfig } from '.'

export const createResource = ({ baseURL, config = getDefaultConfig() }) =>
	axios.create({
		baseURL,
		...config
	})
